import { useEPDDefinitionInformation, useEpdSystemBoundaryGrid } from 'services/api/queries';
import { EPDProductClassificationId } from '../constants';
import { LcaGridNote } from '../grids/GridService';
import usePcrV2 from './usePcrV2';

interface LcaGridHelperResult {
  generalDisclaimerNote: LcaGridNote | null;
  showVariationColumn: boolean;
  createVariationDisclaimerNote(disclaimerNumber: number): LcaGridNote;
}

export default function useLcaGridHelper(
  epdVersionId: string,
  options?: { hasVariationInPcrV2?: boolean }
): LcaGridHelperResult {
  const epdDefinitionInformation = useEPDDefinitionInformation(epdVersionId).data;
  const systemBoundaryGridData = useEpdSystemBoundaryGrid(epdVersionId).data;
  const modules = systemBoundaryGridData?.declaredModules;
  const isPcrV2 = usePcrV2();

  let generalDisclaimerNote: LcaGridNote | null = null;
  const declaresAnyModuleC = !!modules && !!(modules.c1 || modules.c2 || modules.c3 || modules.c4);
  if (declaresAnyModuleC) {
    generalDisclaimerNote = {
      note: 'General disclaimer',
      description:
        'The results of the end-of-life stage (modules C1-C4) should be considered when using the results of the product stage (modules A1-A3/A1-A5 for services).',
    };
  }

  return {
    generalDisclaimerNote,
    showVariationColumn:
      (epdDefinitionInformation?.epdClassification ?? EPDProductClassificationId.SINGLE_PRODUCT_ID) !==
        EPDProductClassificationId.SINGLE_PRODUCT_ID &&
      (!isPcrV2 || !!options?.hasVariationInPcrV2),
    createVariationDisclaimerNote(disclaimerNumber: number) {
      return {
        note: <span>Disclaimer {disclaimerNumber}</span>,
        description: isPcrV2
          ? 'The maximum variation in results between the included products for modules A-C.'
          : 'The maximum variation in results between the included products.',
      };
    },
  };
}
